import { render } from "./TableConfiguration.vue?vue&type=template&id=20b9a298"
import script from "./TableConfiguration.vue?vue&type=script&lang=js"
export * from "./TableConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__